import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processFollowedProject = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_FOLLOWED_PROJECT, item)
}

export const updateFollowedProject = (store, item) => {
    return axios.put(`/api/followed-projects/${item.id}`, item)
        .then(res => {
            res.data.data.status === 'followed'
                ? processFollowedProject(store, res.data.data.project)
                : removeFollowedProject(store, res.data.data.project)
            return res
        })
}

export const removeFollowedProject = (store, item) => {
    store.commit(mutations.REMOVE_FOLLOWED_PROJECT, item)
}
